const mEditionBillingMyPaymentsChangePlanModalCustomized = {
  mEditionBillingMyPaymentsChangePlanModalCustomized: {
    title: 'Plan personalizado',
    messages: 'Tu plan combina más de una licencia, así que el cambio de plan no se hace desde aquí.',
    contactBefore: 'Escríbenos a',
    contactAfter: 'y lo gestionamos contigo.',
    email: 'hola@vidroop.com',
    copyTitle: 'Copiar el correo',
    copied: 'Correo copiado'
  }
}

export default mEditionBillingMyPaymentsChangePlanModalCustomized
